import { MetricWrapper } from './styled';
import { Text } from '@simplywallst/ui-core';

export const GrowthColumnHeaderTooltip = () => (
  <MetricWrapper rowGap="8px">
    <Text typography="tiny" color="spaceGray">
      Forecasted annual earnings and/or sales growth by analysts
    </Text>
  </MetricWrapper>
);
